<template>
  <card>
    <h3 slot="header" class="mb-0">Edit Project Document Template for ({{ model.document_template_name }}) </h3>
    <div class="text-right">
    </div>
    <form class="needs-validation"
          @submit.prevent="submit">
      <div class="form-row">
        <b-col md="12">
          <base-input label="Template Name"
                      name="Template Name"
                      placeholder="Template Name"
                      v-model="model.document_template_name">
          </base-input>
        </b-col>
      </div>

      <base-button type="primary" @click="updateData()" >Update / Save</base-button>
      <base-button type="primary" @click="$router.back()">Cancel</base-button>
      <!-- <div>
        <br>
        <h5 class="text-danger"> Note : <br>
                <i>
                1. To Create New / Update Milestone please proceed to Menu >> Template >> Milestone Template OR "Click" on "Milestone Details"
                <br>
                2. Your cannot swtich / change the Milestone Template anymore once you created your 1st Document Template Detail / Classification. But you can still Create/Update the Milestone Template.
                <br>
                3. All Milestone Template Details will follow according to SELECTED Milestone Template.
                <br>
                4. SET Milestone Template DROPBOX will be disabled once a Document Template Detail / Classification is Created, To check the detail Please Press BACK.
                </i>
        </h5>
      </div> -->
    </form>
  </card>
</template>
<script>
  import BaseSlider from '@/components/BaseSlider'
  import {LoginURL, clientId, clientSecret, apiDomain, getHeader} from '@/assets/js/config.js'
  import axios from 'axios'
  import ErrorFunctionMixin from '@/assets/js/errorFunctionMix.js'

  export default {
    mixins: [ErrorFunctionMixin],
    components: {
      BaseSlider
    },
    created()
    {
      this.model.project_document_template_id = this.$route.params.id

      axios.get(apiDomain + 'template/project_document_template/'+this.model.project_document_template_id, { headers: getHeader() })
      .then ( response => {
        if (response.status === 200)
        {
          this.model.project_document_template_id = response.data.data[0].project_document_template_id
          this.model.document_template_name = response.data.data[0].document_template_name
        }
      })
      .catch ( error => {
        console.log(error.response.status)
        this.errorFunction(error, "Project Document Template Information")
      } );
    },
    data() {
      return {
        model: {
          document_template_name: null,
          project_document_template_id: null,
        },
        document_detail_count: 1,
      }
    },
    methods:
    {
      updateData(){
         if ( !this.model.document_template_name )
        {
          this.$notify({
            message:
              '<b>Invalid Input : All Column are Mandatory in Project Document Template</b> - These field are required.',
            timeout: 10000,
            icon: 'ni ni-bulb-61',
            type: 'danger',
          });
        }
        else
        {
          axios.put(apiDomain + 'template/project_document_template/'+this.model.project_document_template_id, this.model, { headers: getHeader() })
          .then ( response => {
            if (response.status === 200)
            {
                this.$notify({
                message:
                  '<b>Update Project Document Template : ' + this.model.document_template_name + '</b> - Successfully Updated.',
                timeout: 10000,
                icon: 'ni ni-bell-55',
                type: 'default',
                });
                this.$router.back()
            }
          })
          .catch ( error => {
              console.log(error.response.data.errors)
              this.errorFunction(error, "Edit Project Document Template Information", this.model.document_template_name)
          } );
        }
      },
    }
  }
</script>
<style>
</style>
